module.exports = __webpack_public_path__ + "img/icon_sm_wztkrk.b0c20b19.png";